/**
 * Opens an entity details view in a new popup window.
 * Specifying width/height forces a real window instead of a tab.
 */
export function openEntityInNewWindow(entityType: string, entityId: string) {
	const url = `/view/${entityType}/${entityId}`;
	const width = 900;
	const height = 700;
	const left = window.screenX + (window.outerWidth - width) / 2;
	const top = window.screenY + (window.outerHeight - height) / 2;
	window.open(
		url,
		`entity-${entityType}-${entityId}`,
		`width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no`
	);
}
